import { render } from "./close.svg?vue&type=template&id=5467d422"
const script = {}
script.render = render

export default script